module.exports = "/images/category.svg?14ed365fcb5dfdd8dfa0adcb28de5c7f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/category.svg
// module id = 53
// module chunks = 2 4 5